import { Pipe, PipeTransform } from '@angular/core';
import { Field } from 'app/interfaces/fields';
import { FieldRenderService } from '../field-render.service';

@Pipe({
  name: 'isFieldPresentInDocument'
})
export class IsFieldPresentPipe implements PipeTransform {

  constructor(private _fieldRenderService: FieldRenderService) { }

  transform(field: Field): boolean {
    return this._fieldRenderService.isRendered(field.uuid);
  }

}
